var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylContactOnlineMsg"}},[(_vm.isMobileScreen)?_c('ylContactOnlineMsgMobile'):_c('ylContactOnlineMsgPC')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }